import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { FaAngleRight } from '@react-icons/all-files/fa/FaAngleRight'

import JobsList from './JobsList'

const proxyURL = 'https://g48dljlq67.execute-api.us-east-2.amazonaws.com/prd/'

class Jobs extends Component {
  constructor(props) {
    super(props)

    this.state = {
      jobData: []
    }
  }

  componentDidMount() {
    this.getJobs()
  }

  getJobs = () => {
    const categories = {}

    axios
      .get(proxyURL)
      .then(workdayData => {
        /*

        sorts data into a sorted array objects by team
        EX:
        [
          {
            Business Development: [{job}, {job}]
          },
          {
            Collections Analytics: [{job}, {job}]
          },
        ]
        */
        const {
          data: { Report_Entry: jobs }
        } = workdayData
        const externalJobs = jobs.filter(job => job?.External_Apply_URL)
        // eslint-disable-next-line no-restricted-syntax
        for (const job of externalJobs) {
          const category = job.jobFamilyGroup
          /* eslint-disable no-unused-expressions */
          categories[category] === undefined
            ? (categories[category] = [job])
            : categories[category].push(job)
        }

        // ensures list is in alphabetical order
        const listOfCategories = Object.keys(categories).sort((a, b) => a.localeCompare(b))

        const sortedCategoriesAndJobs = listOfCategories.map(cat => ({ [cat]: categories[cat] }))

        this.setState({ jobData: sortedCategoriesAndJobs })
      })
      /* eslint-disable no-console */
      .catch(err => console.log(err))
  }

  render() {
    const { scrollToJobs } = this.props
    const { jobData } = this.state

    const jobCopy = jobData
    const third = Math.floor(jobCopy.length / 3 + 1)

    const arrayFirst = jobCopy.slice(0, third)
    const arraySecond = jobCopy.slice(third, third * 2)
    const arrayThird = jobCopy.slice(third * 2, jobCopy.length)

    return (
      <section className="jobs" ref={scrollToJobs}>
        <div className="container__inner">
          <div className="jobs__list-box">
            <ul className="jobs__list">
              {arrayFirst.map(item => {
                const category = Object.keys(item)[0]

                return (
                  <li className="jobs__item" key={category}>
                    {/* eslint-disable-next-line */}
                    <a className="jobs__link" href="" tabIndex="0">
                      {category}
                    </a>

                    <div className="jobs__dropdown">
                      <JobsList list={item[category]} />
                    </div>
                  </li>
                )
              })}
            </ul>

            <ul className="jobs__list">
              {arraySecond.map(item => {
                const category = Object.keys(item)[0]

                return (
                  <li className="jobs__item" key={category}>
                    {/* eslint-disable-next-line */}
                    <a className="jobs__link" href="" tabIndex="0">
                      {category}
                    </a>

                    <div className="jobs__dropdown">
                      <JobsList list={item[category]} />
                    </div>
                  </li>
                )
              })}
            </ul>

            <ul className="jobs__list">
              {arrayThird.map(item => {
                const category = Object.keys(item)[0]

                return (
                  <li className="jobs__item" key={category}>
                    {/* eslint-disable-next-line */}
                    <a className="jobs__link" href="" tabIndex="0">
                      {category}
                    </a>

                    <div className="jobs__dropdown">
                      <JobsList list={item[category]} />
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div>
            <a
              id="view-all-open-positions"
              href="https://avant.wd503.myworkdayjobs.com/External_Careers"
              target="_blank"
              rel="noreferrer"
              className="button button--tertiary jobs__view-all-button"
              // onMouseOver={onMouseOver}
              // onFocus={onMouseOver}
            >
              <FaAngleRight
                className="arrow-right"
                title="view-all-open-positions"
                alt="Arrow right icon"
                aria-labelledby="view-all-open-positions"
              />
              View All Open Positions
            </a>
          </div>
        </div>
      </section>
    )
  }
}

Jobs.propTypes = {
  scrollToJobs: PropTypes.object.isRequired
}

export default Jobs
